module.exports = __webpack_public_path__ + "img/crown.82e435de.png";